import { ToastLevel } from '@philips-emr/tws-constants';
import { FileService } from '@philips-emr/tws-core/lib/services';

import { ToastService } from './toast-service';

interface Download {
  endpoint: string,
  name?: string;
  parameters?: {},
}

class DownloadService {

  static of({ endpoint, name, parameters }: Download): void {
    ToastService.open({ message: 'beneficiary.download-iniciado', level: ToastLevel.INFORMATION });

    FileService.download(endpoint, name, parameters)
      .catch(() => ToastService.open({ message: 'beneficiary.arquivo-nao-localizado', level: ToastLevel.CAUTION }));
  }
}

export {
  DownloadService,
};
